function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_keyboard"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.331 1.331c-.923.177-1.624.988-1.624 1.962v10c0 1.103.897 2 2 2h13.586l2.707 2.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm.293 14.707v-10h1.586l4.069 4.069c-.381.142-.655.5-.655.931 0 .553.447 1 1 1 .431 0 .789-.274.931-.655l1.655 1.655h-2.586c-.553 0-1 .447-1 1s.447 1 1 1h4.586l1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20 5h-9c-.553 0-1 .447-1 1s.447 1 1 1h9v9c0 .553.447 1 1 1s1-.447 1-1v-9c0-1.103-.897-2-2-2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 9,
  r: 1
})));

var Svg075Keyboard = function Svg075Keyboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg075Keyboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/075-keyboard.36200296.svg";
export { ForwardRef as ReactComponent };